import React, { FC, memo, useCallback } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import Image from 'next/image'
import { Button } from '@ucheba/ui/components/Button/desktop'
import ArrowRightCircleIcon from '@ucheba/ui/icons/icon__arrow-right_circle-outline.svg'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { getApiImageUrl } from '@ucheba/utils/helpers/string'
import Link from 'next/link'
import { IExamsListItemProps } from '../types'
import SC from '../base/ExamsListItem.styles'
import { forAbiturients } from '../../../routs'
import { egeSubjectsExсeptions } from '../constants'

const { Block, Exam: ExamSC } = SC

const Exam = styled(ExamSC)`
  padding-right: ${sv.spacing.xxsmall};
  display: inline-flex;
`

/** Специальность */
const ExamsListItem: FC<IExamsListItemProps> = (props) => {
  const { subjects, getLinkProps } = props
  const linkProps = getLinkProps(props)

  const isExludeExam = useCallback((id: number) => {
    return egeSubjectsExсeptions.includes(id)
  }, [])

  return (
    <Block>
      <Grid spacing='small' nowrap justifyContent='space-between'>
        <GridCol width='auto' shrink='initial'>
          {subjects.map(({ id: subjectId, iconUrl, name, slug }) => (
            <Exam key={subjectId}>
              {iconUrl && (
                <Image src={getApiImageUrl(iconUrl)} width={28} height={20} alt={name} />
              )}
              {isExludeExam(subjectId) ? (
                <Text as='span' firstLetterUppercase color='black'>
                  {name}
                </Text>
              ) : (
                <Text as='span' firstLetterUppercase color='black' html={false}>
                  <Link
                    href={`${forAbiturients.ege.path}/${
                      slug === 'foreignlanguage' ? 'english' : slug
                    }`}
                    style={{ color: 'inherit' }}
                  >
                    {name}
                  </Link>
                </Text>
              )}
            </Exam>
          ))}
        </GridCol>

        <GridCol width='auto'>
          <Link href={linkProps.href}>
            <Button
              view='link'
              size='small'
              EndIcon={<ArrowRightCircleIcon width='20px' height='20px' />}
            >
              {linkProps.name}
            </Button>
          </Link>
        </GridCol>
      </Grid>
    </Block>
  )
}

export { ExamsListItem }
export default memo(ExamsListItem)
